import { z } from "zod";

export const ReviewClientSchema = z.object({
    id: z.number(),
    first_name: z.string(),
    last_name: z.string(),
    photo: z.string().nullable().optional(),
});

export const ReviewSchema = z.object({
    id: z.number(),
    rate: z.number(), // float rating
    comment: z.string().nullable(),
    expert_response: z.string().nullable(),
    response: z.string().nullable(), // Appears to be legacy/deprecated
    is_edited: z.boolean(),
    review_source: z.string().nullable(),
    communication: z.number().nullable(), // rating 1-5
    quality: z.number().nullable(), // rating 1-5
    recommendation: z.string().nullable(),
    time_to_start: z.number().nullable(), // rating 1-5
    value_for_money: z.number().nullable(), // rating 1-5
    value_range: z.string().nullable(),
    created_at: z.string(), // ISO8601 datetime string
    updated_at: z.string(), // ISO8601 datetime string
    client: ReviewClientSchema.nullable()
});